'use client';

import { useAppDispatch } from '@/app/lib/store/hooks';
import { setReturnTo } from '@/app/lib/store/return-to-slice';
import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

export default function DispatchReturnTo() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const dispatch = useAppDispatch();

  useEffect(() => {
    const params = new URLSearchParams(searchParams);

    const currentUrl = params.size
      ? `${pathname}?${params.toString()}`
      : pathname;

    dispatch(setReturnTo(currentUrl));
  }, [dispatch, pathname, searchParams]);

  return null;
}
